<template>
  <div class="evolution-report">
    <h4 v-if="title" class="report-title">{{ title }}</h4>
    <ReportFilterBadge :metadata="metadata" />
    <div class="years-grid" :style="gridStyle">
      <div v-for="entry in entries" :key="entry.year" class="year-block">
        <h5 class="year-title">{{ entry.year }}</h5>
        <div class="year-body">
          <component :is="reportComponent" :data="entryData(entry)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TableReport from '@/components/elements/TableReport'
  import ListReport from '@/components/elements/ListReport'
  import ReportFilterBadge from '@/components/elements/ReportFilterBadge'

  export default {
    name: 'EvolutionTextualReport',
    components: { TableReport, ListReport, ReportFilterBadge },
    props: {
      title: String,
      metadata: Object,
      reportType: {
        type: String,
        default: 'table'
      },
      entries: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      reportComponent () {
        return this.reportType === 'list' ? ListReport : TableReport
      },
      maxColumnCount () {
        let max = 0
        this.entries.forEach(entry => {
          const report = entry.data && entry.data.report
          if (!report || !Array.isArray(report.columns)) {
            return
          }
          const hasGroupColumn = Array.isArray(report.rows) &&
            report.rows.some(row => row.hasOwnProperty('group'))
          const columnCount = report.columns.length + (hasGroupColumn ? 1 : 0)
          if (columnCount > max) {
            max = columnCount
          }
        })
        return max
      },
      cardMinWidth () {
        if (this.reportType === 'list' || this.maxColumnCount === 0) {
          return 320
        }
        const widthPerColumn = 130
        const horizontalPadding = 40
        const computed = this.maxColumnCount * widthPerColumn + horizontalPadding
        return Math.min(Math.max(computed, 320), 1000)
      },
      gridStyle () {
        return {
          gridTemplateColumns: `repeat(auto-fill, minmax(${this.cardMinWidth}px, 1fr))`
        }
      }
    },
    methods: {
      entryData (entry) {
        return Object.assign({}, entry.data, { title: null, metadata: null })
      }
    }
  }
</script>

<style scoped>
  .evolution-report {
    text-align: left;
  }
  .report-title {
    color: #333;
    text-align: left;
    margin-bottom: 8px;
  }
  .years-grid {
    display: grid;
    gap: 16px;
    align-items: start;
  }
  .year-block {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 10px 12px;
    background: #fff;
    min-width: 0;
  }
  .year-body {
    overflow-x: auto;
  }
  .year-title {
    color: #fff;
    background: #488ab3;
    text-align: center;
    font-weight: bold;
    margin: -10px -12px 10px;
    padding: 6px 12px;
    border-radius: 4px 4px 0 0;
  }
</style>



// WEBPACK FOOTER //
// EvolutionTextualReport.vue?0132daaa